import React, { useState, useEffect, useRef } from 'react';
import { InputGroup } from 'react-bootstrap'
import { useTranslate } from 'react-polyglot';
import "./styles/SelectColor.scss";

function SelectColor(props) {
    const t = useTranslate();
    
    const value = props.value;

    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    const [display, setDisplay] = useState(false);

    const usableColors = [
        "#C14E44",
        "#6662CB",
        "#2E8A45",
        "#95B03B",
        "#33997E",
        "#9671D0",
        "#772867",
        "#50541C",
        "#CBB862",
        "#CB7762",
        "#A45D37",
        "#ABE0A3",
    ];

    const ref = useRef(null);
    const buttonClick = () => setDisplay(!display);

    useEffect(() => {
        function handleClickOutside(event) {
            // @ts-ignore
            if (ref.current && !ref.current.contains(event.target)) {
                setDisplay(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [ref])


    return (
        <InputGroup className="mb-3" >
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
                : null}
            <div className="container form-control" style={{
                backgroundColor: props.disabled ? "#f5f5f5" : "",
                cursor: props.disabled ? "auto" : "pointer",
            }} onClick={() => props.disabled != true ? buttonClick() : null}>

                <div className="chosencolordisplay" style={{ backgroundColor: value }}></div>

                {display && (
                    <div className="pickercontainer" onClick={(e) => e.stopPropagation()}>
                        <div className="pickerTriangle"></div>
                        <div className="colorHeader">
                            <div>{t("wizard.field.selectcolor.pickertitle")}</div>
                        </div>
                        <div className="listContainer">
                            {usableColors.map((i, index) => (
                                <div className="colorcontainer" key={index}>
                                    <div className="colordisplay" style={{ backgroundColor: i }} onClick={() => {
                                        handleChange(i);
                                        setDisplay(false);
                                    }}></div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </InputGroup>
    )
}

export default SelectColor;